import { motion } from "framer-motion";

export const ArticlesPanel = ({ articles = [] }) => (
  <motion.div
    initial={{ opacity: 0, y: 8 }}
    animate={{ opacity: 1, y: 0 }}
    className="panel lg:col-span-6 flex flex-col min-h-[200px] max-h-[420px]"
    data-testid="articles-panel"
  >
    <div className="panel-header shrink-0">
      <h3 className="font-display text-sm font-bold uppercase tracking-tight">News · Articles</h3>
      <span className="label-micro">{articles.length} rows</span>
    </div>
    <div className="panel-scroll-body divide-y divide-border">
      {articles.length === 0 ? (
        <p className="p-4 text-sm text-text-secondary font-mono">No articles in database.</p>
      ) : (
        articles.map((a) => (
          <article key={a.id} className="p-3 hover:bg-surface-muted">
            <div className="flex justify-between gap-2 text-[10px] uppercase tracking-wider text-text-secondary">
              <span>{a.source}</span>
              <span className={a.sentiment === "NEGATIVE" ? "text-magenta" : "text-positive"}>
                {a.sentiment} · {a.score}
              </span>
            </div>
            <h4 className="text-sm font-display font-bold mt-1">{a.title}</h4>
            <p className="text-[11px] text-text-secondary mt-1 line-clamp-2">{a.reason || a.tickers}</p>
          </article>
        ))
      )}
    </div>
  </motion.div>
);

export default ArticlesPanel;
